import { getLocale } from '../../misc';

const getUpdatedLocaleValues = value => {
  const toEn = {
    Existant: 'Existing',
    Nouveau: 'New',
    Renouvellement: 'Renewal',
    'Télématique Raven': 'Raven'
  };
  const toFr = {
    Existing: 'Existant',
    New: 'Nouveau',
    Renewal: 'Renouvellement',
    Raven: 'Télématique Raven'
  };
  const locale = getLocale();
  const listToCheck = locale === 'fr-CA' ? toFr : toEn;
  return listToCheck[value] || value;
};

export default getUpdatedLocaleValues;
